module.exports = __webpack_public_path__ + "static/media/Slide3.27878f3f.jpeg";